import React from "react";
import loadable from "@loadable/component";
import { tw } from "@careinfo/tailwind";

const CreditNoteComponent = loadable(
  () => import("../../components/CreditNote")
);
const CreditNote = () => {
  return (
    <>
      <div className={tw`flex items-center justify-between`}>
        <h1 className={tw`font-semibold text-2xl leading-8`}>Credit Note</h1>
      </div>
      <CreditNoteComponent />
    </>
  );
};

export default CreditNote;
